import { Box, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { AdvancedFilter, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { HatchcoverFilter } from '../../models/hatchcover-filters.model'
import { HatchcoverFilterUIStore } from '../../store/hatchcover-filter.ui-store'
import { HatchCoverMoveFilterForm } from './HatchCoverMoveFilterForm'

interface ToolbarProps {
  opened: number
  closed: number
  uiStore: HatchcoverFilterUIStore
}

export const HatchCoverToolbar = observer(({ opened, closed, uiStore }: ToolbarProps) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()
  const [open, setOpen] = useState(false)

  const handleSubmit = (filter: HatchcoverFilter) => {
    uiStore.setFilter(filter)
    uiStore.toggle()
  }

  const openFilter = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  const handleFilterEmpty = () => {
    handleClose()
  }

  const handleReset = () => {
    uiStore.setFilter(null)
    uiStore.toggle()
    handleFilterEmpty()
  }

  return (
    <Stack
      display={'flex'}
      flexDirection='row'
      gap={theme.customSpacing.m}
      alignItems={'center'}
      p={theme.customSpacing.m}
      justifyContent={'space-between'}
    >
      <Stack gap={theme.customSpacing.m} display={'flex'} flexDirection='row'>
        <Stack
          display={'flex'}
          flexDirection='row'
          gap={theme.customSpacing.m}
          alignItems={'center'}
        >
          <Typography variant='inherit'>{t('opened', 'Opened')}</Typography>
          <Typography variant='h4'>{opened}</Typography>
        </Stack>
        <Stack
          display={'flex'}
          flexDirection='row'
          gap={theme.customSpacing.m}
          alignItems={'center'}
        >
          <Typography variant='inherit'>{t('closed', 'Closed')}</Typography>
          <Typography variant='h4'>{closed}</Typography>
        </Stack>
      </Stack>
      <Box width='30%' display={'flex'} justifyContent={'end'} position={'relative'}>
        <AdvancedFilter
          open={open}
          formId='hatch-cover-move-filters'
          onOpenFilter={openFilter}
          onClose={handleClose}
          filterActionLabel={t('apply', 'Apply')}
          resetActionLabel={t('reset', 'Reset')}
          onFilter={handleFilterEmpty}
          filterTooltip={t('advancedFilter', 'Advanced filter')}
          onReset={handleReset}
        >
          <HatchCoverMoveFilterForm
            id='hatch-cover-move-filters'
            filter={uiStore.filter}
            equipmentOptions={uiStore.uniqueEquipments}
            onSubmit={handleSubmit}
          />
        </AdvancedFilter>
      </Box>
    </Stack>
  )
})
